<template>
  <div v-if="anchors.length > 0 || data.type.length === 1" class="block-subnav">
    <div class="block-subnav__wrapper">
      <div ref="navBarRef" class="block-subnav__navbar">
        <BlockSubnavAnchor v-if="data.has_dynamic_anchors" :data="anchors" />
        <BlockSubnavLink v-else-if="data.type && data.type.length === 1" :data="data.type[0]" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const anchorsStore = useAnchorStore();
const anchors = computed(() => anchorsStore.getAnchors);
</script>

<style lang="scss">
.block-subnav {
    @include grid-full();
    @include fluid('margin-bottom', 40px, 60px);

    & + .atom-heading {
        @include fluid('margin-top', 60px, 60px);

        @include mobile {
            margin-top: 0;
        }
    }
}

.block-subnav__wrapper {
    @include grid-layout();
    @include remove-scrollbars();

    width: 100%;
    max-width: var(--grid-width);
    padding: 0 var(--page-padding);
    margin: 0 auto;
    overflow-y: auto;
    white-space: nowrap;

    @include tablet-portrait {
        display: flex;
        padding: 0;
        white-space: nowrap;
    }
}

.block-subnav__navbar {
    @include grid-columns(3, 14);
    flex-wrap: nowrap;

    padding: 40px 0px;
    border: 2px solid $C_GREEN_DARK_OPACITY_10;
    border-radius: 12px;
    overflow-y: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
        display: none;
    }
    @include tablet {
        @include grid-columns(2, 10);
    }

    @include tablet-portrait() {
        overflow: unset;
        margin-right:var(--page-padding);
        margin-left:var(--page-padding);
    }

    @include mobile {
        padding: 18px 19px 18px 19px;
    }
}
</style>
